<div class="result {{viewType}} {{indexName}}">
  <a [routerLink]="hit.routerLink" class="result-icon">
    <img class="app-details-logo" src="/assets/icons/icon-72x72-grey.png" alt="App Details Logo" />
  </a>
  <ul class="result-meta result-meta-header align-items-end">
    <li class="result-meta-item">
      <div class="badge badge-warning d-flex align-items-center py-1 px-2" enTooltip
        title="This bundle ID is not listed on Google Play or Apple App Store.">
        <i class="fa fa-warning mr-1"></i>
        <span>Not Listed</span>
      </div>
    </li>
    <li class="result-meta-item">
      <div class="badge badge-info d-flex align-items-center py-1 px-2">
        <i class="fa fa-caret-right mr-1"></i>
        <span>Mobile</span>
      </div>
    </li>
  </ul>
  <div class="result-body">
    <h3 class="result-title" *ngIf="hit.appId" enTooltip [title]="hit.appId">
      <a [routerLink]="hit.routerLink">
        <span [innerHTML]="hit | highlight: 'appId'"></span>
      </a>
    </h3>
    <ul class="result-meta">
      <li class="result-meta-item">
        App Store: <b>Unknown</b>
        <i class="fa fa-info-circle" enTooltip
          title="This bundle ID is not listed on Google Play or Apple App Store."></i>
      </li>
      <li class="result-meta-item justify-content-between" *ngIf="hit.publisherName">
        <div class="result-meta-item-block developer">
          Publisher:
          <span *ngIf="!isEnterprise" class="">{{ hit.publisherName }}</span>
          <button *ngIf="isEnterprise" mrt-attribute-btn [indexName]="indexName" attribute="publisherName"
            [value]="hit.publisherName" title="View all apps by this publisher" enTooltip
            class="btn btn-link result-meta-link"><span class="">{{ hit.publisherName }}</span>
          </button>
        </div>
      </li>
      <li class="result-meta-item justify-content-between" *ngIf="hit.kydDeveloperName">
        <div class="result-meta-item-block developer">
          Developer:
          <span *ngIf="!isEnterprise" class="">{{ hit.kydDeveloperName }}</span>
          <button *ngIf="isEnterprise" mrt-attribute-btn [indexName]="indexName" attribute="kydDeveloperName"
            [value]="hit.kydDeveloperName" title="View all apps by this publisher" enTooltip
            class="btn btn-link result-meta-link"><span class="">{{ hit.kydDeveloperName }}</span>
          </button>
        </div>
      </li>
      <li class="result-meta-item" *ngIf="hit.iabPrimaryCategory">
        Category:
        <ng-container *ngIf="hit.iabPrimaryCategory != 'N/A' else notApplicable">
          <button mrt-attribute-btn [indexName]="indexName" attribute="iabPrimaryCategory"
            [value]="hit.iabPrimaryCategory" class="btn btn-link result-meta-link">{{ hit.iabPrimaryCategory
            }}</button>
        </ng-container>
      </li>
      <li class="result-meta-item" *ngIf="hit.iabSubCategory">
        Sub-Category:
        <ng-container *ngIf="hit.iabSubCategory != 'N/A' else notApplicable">
          <button mrt-attribute-btn [indexName]="indexName" attribute="iabSubCategory" [value]="hit.iabSubCategory"
            class="btn btn-link result-meta-link">{{ hit.iabSubCategory
            }}</button>
        </ng-container>
      </li>
      <li class="result-meta-item" *ngIf="hit.downloads">
        Downloads: <b>{{ hit.downloads | roundsigrange }}</b>
      </li>
      <li class="result-meta-item" *ngIf="hit.hasPrivacyLink">
        <img height="16" src="/assets/images/icon-indicator-yes-2.svg" />
        <button mrt-attribute-btn attribute="hasPrivacyLink" [indexName]="indexName" [value]="hit.hasPrivacyLink"
          class="btn btn-link result-meta-link">Privacy Policy detected
        </button>
      </li>
    </ul>
  </div>
</div>
<ng-template #notApplicable>
  <b>Not Applicable</b>
</ng-template>